







import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class MenuIcon extends Vue {
  hamburguer = true
  get iconClass () {
    return this.hamburguer
      ? ['glyphicon-menu-hamburger', 'spin-reverse-animation']
      : ['glyphicon-option-vertical', 'spin-animation']
  }

  onIconClicked () {
    this.hamburguer = !this.hamburguer
    this.$emit('menu-toggled', this.hamburguer)
  }
}
